import TypographyPrimary from 'components/Typography/Primary'
import AiMessageMarkdown from 'modals/AIChatModal/components/ChatMessageList/components/AiMessageMarkdown'
import { useRef, useState } from 'react'
import { StyledShowMoreButton } from './HeaderItem'
import CopyButton from 'components/CopyButton'
import { StyledRow } from '../Playground/Subnets/Cortext/Settings/SettingsStyles.css'

const ResponseBody = ({ data }: { data: any }) => {
    const [showAll, setShowAll] = useState(false)
    const topRef = useRef<HTMLDivElement>(null)

    const handleShowMore = () => {
        setShowAll(!showAll)
        if (showAll && topRef.current) {
            setTimeout(() => {
                topRef.current?.scrollIntoView({ behavior: 'instant', block: 'center' })
            }, 1)
        }
    }

    return (
        <>
            <div ref={topRef} />

            <StyledRow>
                <TypographyPrimary size='medium' value='Body' bold />
                <CopyButton value={data?.response_text || 'N/A'} />
            </StyledRow>

            <AiMessageMarkdown>
                {showAll
                    ? data?.response_text.slice(0, 1000) || 'N/A'
                    : (data?.response_text || 'N/A').slice(0, 500)}
            </AiMessageMarkdown>

            {data?.response_text && data.response_text.length > 500 && (
                <StyledShowMoreButton onClick={handleShowMore}>
                    {showAll ? 'Show less' : 'Show more'}
                </StyledShowMoreButton>
            )}
        </>
    )
}

export default ResponseBody
